// @ts-check
export const FUNCTIONS_ENDPOINT = `/.netlify/functions`
